import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ENTRY_MODULES } from "@/lib/perms";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const { pathname } = useLocation();
  if (!checked) {
    return <div className="flex min-h-screen items-center justify-center bg-ivory text-anthracite/40">…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role === "member") return <Navigate to="/account" replace />;
  if (user.role !== "admin" && pathname !== "/admin" && !ENTRY_MODULES.some((m) => pathname.startsWith(m))) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
